import { type getTranslationFn } from 'src/utils/get-translation-fn';

// todo BNPL-7199 - fix plural form handling
export const getPaymentText = (
  installmentsCount: number,
  t: ReturnType<typeof getTranslationFn>
) => {
  return installmentsCount < 11
    ? t('payments_few', {
        installmentsCount,
      })
    : t('payments_other', {
        installmentsCount,
      });
};
